import React from "react";
import TopSellingItem from "./TopSellingItem";
import TopSellingTop from "./TopSellingTop";

const TopSelling = () => {
    return (
        <div className="_creator_top_wrap">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                        <div className="_stats_title_wrap">
                            <h2 className="_creator_title">Top selling NFTs</h2>
                        </div>
                    </div>
                </div>
                <div className="_selling_nft_btn_main_wrap">
                    <div className="row">
                        <TopSellingTop/>
                    </div>
                    <div className="row">
                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                            <div className="_fav_table_item_header">
                                <ul className="_fav_table_item_header_main">
                                    <li className="_fav_table_header_item _top_selling_header_item">
                                        Collections <span className="_top_selling_header_ic"><svg
                                            xmlns="http://www.w3.org/2000/svg" width="10" height="6" fill="none"
                                            viewBox="0 0 10 6">
                                            <path fill="#000"
                                                d="M8.682.14 5.236 3.585 1.791.14.736 1.194l4.5 4.5 4.5-4.5L8.682.14Z" />
                                        </svg>
                                        </span>
                                    </li>
                                    <li className="_fav_table_header_item _top_selling_header_item">
                                        Volume<span className="_top_selling_header_ic"><svg xmlns="http://www.w3.org/2000/svg"
                                            width="10" height="6" fill="none" viewBox="0 0 10 6">
                                            <path fill="#000"
                                                d="M8.682.14 5.236 3.585 1.791.14.736 1.194l4.5 4.5 4.5-4.5L8.682.14Z" />
                                        </svg>
                                        </span>
                                    </li>
                                    <li className="_fav_table_header_item _top_selling_header_item">
                                        24h %<span className="_top_selling_header_ic"><svg xmlns="http://www.w3.org/2000/svg"
                                            width="10" height="6" fill="none" viewBox="0 0 10 6">
                                            <path fill="#000"
                                                d="M8.682.14 5.236 3.585 1.791.14.736 1.194l4.5 4.5 4.5-4.5L8.682.14Z" />
                                        </svg>
                                        </span>
                                    </li>
                                    <li className="_fav_table_header_item _top_selling_header_item">
                                        7d %<span className="_top_selling_header_ic"><svg xmlns="http://www.w3.org/2000/svg"
                                            width="10" height="6" fill="none" viewBox="0 0 10 6">
                                            <path fill="#000"
                                                d="M8.682.14 5.236 3.585 1.791.14.736 1.194l4.5 4.5 4.5-4.5L8.682.14Z" />
                                        </svg>
                                        </span>
                                    </li>
                                    <li className="_fav_table_header_item _top_selling_header_item">
                                        Floor price<span className="_top_selling_header_ic"><svg
                                            xmlns="http://www.w3.org/2000/svg" width="10" height="6" fill="none"
                                            viewBox="0 0 10 6">
                                            <path fill="#000"
                                                d="M8.682.14 5.236 3.585 1.791.14.736 1.194l4.5 4.5 4.5-4.5L8.682.14Z" />
                                        </svg>
                                        </span>
                                    </li>
                                    <li className="_fav_table_header_item _top_selling_header_item">
                                        Owners<span className="_top_selling_header_ic"><svg xmlns="http://www.w3.org/2000/svg"
                                            width="10" height="6" fill="none" viewBox="0 0 10 6">
                                            <path fill="#000"
                                                d="M8.682.14 5.236 3.585 1.791.14.736 1.194l4.5 4.5 4.5-4.5L8.682.14Z" />
                                        </svg>
                                        </span>
                                    </li>
                                    <li className="_fav_table_header_item _top_selling_header_item">
                                        Item<span className="_top_selling_header_ic"><svg xmlns="http://www.w3.org/2000/svg"
                                            width="10" height="6" fill="none" viewBox="0 0 10 6">
                                            <path fill="#000"
                                                d="M8.682.14 5.236 3.585 1.791.14.736 1.194l4.5 4.5 4.5-4.5L8.682.14Z" />
                                        </svg>
                                        </span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="_selling_main_table_wrap">
                        <div className="row">
                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                <TopSellingItem/>
                            </div>
                        </div>
                        <div className="row my-3">
                            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                                <div className="_load_more_btn_wrap text-center">
                                    <button className="_stat_item_load_btn">
                                        Load More
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default TopSelling;